import React from "react";
import { DatasetCircles } from "@/components/analysisModules/TopicClusteringTreeView/DatasetCircles";

/**
 * The dataset circles the Topics cards carry, in a cell. `value` is the
 * row's array of content types; `titleByContentType` names them.
 */
const TableDatasetCircles = ({ value, titleByContentType = {} }) => {
  if (!value?.length) return null;
  return <DatasetCircles datasets={value} titleByContentType={titleByContentType} />;
};

export default TableDatasetCircles;
